import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'logged_out_retailers-discover_page_all_filters_pill-click';

/**
 * This event tracks when users click on the 'All Filters' pill on the discover page to show/hide the filter sidebar.
 */
export function trackLoggedOutRetailersDiscoverPageAllFiltersPillClick(
  Action: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { Action },
  });
}
